export const SAVE_TABLE_STRUCTURE = 'SAVE_TABLE_STRUCTURE';
export const SAVE_UPLOAD_SESSIONS = 'SAVE_UPLOAD_SESSIONS';
export const SAVE_SUBSCRIPTION = 'SAVE_SUBSCRIPTION';
export const SET_ACTIVE_INFO_HEADER = 'SET_ACTIVE_INFO_HEADER';
